import React, { CSSProperties } from 'react';
import LazyImage from 'react-lazy-blur-image';

import { ImageResizer } from '../../Types/ImageResizer';

import './HomeHeader.scss';
import { Link } from 'react-router-dom';
import { useSessionStorage } from '../../hooks/useSessionStorage';

export interface HomeHeaderProps {
	mainImage: ImageResizer;
	title: string;
	subTitle: string;
	video: any;
	buttonText: string;
}

export default function HomeHeader({ mainImage, title, subTitle, video, buttonText }: HomeHeaderProps) {
	const [language] = useSessionStorage('language', '');
	return (
		<div className="homeContent">
			<div className="homeImage">
				{video ? (
					<video autoPlay loop muted className="homeVideoContent">
						<source src={video.src} type="video/mp4" />
					</video>
				) : (
					<LazyImage
						placeholder={mainImage.sm.src}
						uri={mainImage.original.src}
						render={(src: string, style: CSSProperties) => <img src={src} style={style} alt="homeImage" />}
					/>
				)}
			</div>
			<div className="imageBackground">
				<div className="homeTitleWrapper">
					<div className="homeTitle" dangerouslySetInnerHTML={{ __html: `${title}` }} />
					<div className="homeSubTitle" dangerouslySetInnerHTML={{ __html: `${subTitle}` }} />
					{language !== 'ua' && (
						<Link to="/myteam" className="homeInvolvedButton">
							{buttonText}
						</Link>
					)}
				</div>
			</div>
		</div>
	);
}
